enum LayoutGap {
  NONE = '0',
  XSMALL = '8px',
  SMALL = '16px',
  MEDIUM = '24px',
  LARGE = '32px',
  XLARGE = '64px'
}

export default LayoutGap;
